import { ref } from 'vue';

const pstate = ref<any>(null);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useState ($state?: any): any {
    if (!pstate.value && !$state) {
        throw new Error('请先初始化ApisV1');
    }
    if (!pstate.value) {
        pstate.value = $state;
    }
    return pstate.value;
}
